module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular.89889688147bd7575d6327160d64e760.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
 ** module id = 388
 ** module chunks = 0
 **/